import * as React from 'react'

// import * as classnames from 'classnames'
import * as styles from './videoOverlay.css'

import posed from 'react-pose'

import { StoreComponent, injectStores } from '../../../../store'
import { observer } from 'mobx-react'
// import { observable } from 'mobx'

import enhanceWithClickOutside from 'react-click-outside'
import { IntroPlayer } from '../../introplayer/introplayer'

const overlayProps = {
  open: { opacity: 1, scale: 1, transition: { duration: 1000, ease: 'easeOut' } },
  closed: { opacity: 0, scale: 0, transition: { duration: 1000, ease: 'easeIn' } }
}

const Sidebar = posed.div(overlayProps)

interface IProps {
  onCloseClick: () => void
  content: any
  open: boolean
}

@injectStores
@enhanceWithClickOutside
@observer
export class VideoOverlay extends StoreComponent<IProps> {

  handleClickOutside () {
    this.props.onCloseClick()
  }

  render () {
    // console.log('video overlay props', this.props)
    let player: JSX.Element | null = null
    if (this.props.content && this.props.content.urlVideo) {
      player = <IntroPlayer
                chapter={this.props.content}
                onCloseClick={this.props.onCloseClick}
                active={true}
                isBg={false}
              />
    }

    return (
        <Sidebar pose={this.props.open ? 'open' : 'closed'} key='video-overlay' className={styles.videoOverlay}>
          {/* <div className={styles.videoOverlay}> */}
            {player}
          {/* </div> */}
        </Sidebar>
    )
  }
}



// WEBPACK FOOTER //
// ./src/modules/storydoc/book/overlays/videoOverlay.tsx